export const DATATABLE_UPDATE_COLUMNS_TABLE = 'DATATABLE_UPDATE_COLUMNS_TABLE'
export const DATATABLE_UPDATE_COLUMNS_TABLE_CURRICULUM = 'DATATABLE_UPDATE_COLUMNS_TABLE_CURRICULUM'
export const DATATABLE_UPDATE_ROWS_PER_PAGE = 'DATATABLE_UPDATE_ROWS_PER_PAGE'
export const DATATABLE_UPDATE_SKIP = 'DATATABLE_UPDATE_SKIP'

export const updateColumnTable = (module, list = []) => ({
	type: DATATABLE_UPDATE_COLUMNS_TABLE,
	payload: { module, list }
})
export const updateColumnTableCurriculum = (curriculumId, module, list = [], firstTime = false) => ({
	type: DATATABLE_UPDATE_COLUMNS_TABLE_CURRICULUM,
	payload: { curriculumId, module, list, firstTime }
})
export const updateRowsPerPage = (module, length) => ({
	type: DATATABLE_UPDATE_ROWS_PER_PAGE,
	payload: { module, length }
})
export const updateSkip = (module, skip) => ({
	type: DATATABLE_UPDATE_SKIP,
	payload: { module, skip }
})
